import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { ReactComponent as TotalUsers } from '~/assets/svg/totalUsers.svg';
import { ReactComponent as IconMessage } from '~/assets/svg/IconMessage.svg';
import { ReactComponent as MessageYellow } from '~/assets/svg/MessageYellow.svg';
import { ReactComponent as IconConversation } from '~/assets/svg/IconConversation.svg';
import { ReactComponent as IconMessageDos } from '~/assets/svg/IconMessageDos.svg';
import {
  AreaChart,
  XAxis,
  YAxis,
  Area,
  Tooltip,
  CartesianGrid,
} from 'recharts';
import { useQuery } from '@apollo/client';
import { GET_STATS } from '~/services';
import { useParams } from 'react-router-dom';
import { StatsCard } from './components/StatsCard';
import { NumberComponent } from '../../shared/NumberComponent';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Head } from '~/components/shared/Head';
import moment from 'moment';

const ConsumerStats = () => {
  const [t] = useTranslation('consumer_stats');
  const formatter = new Intl.NumberFormat('es-CO', {
    style: 'decimal',
    maximumFractionDigits: 1,
  });
  const { agentId } = useParams();
  const { data: stats, loading } = useQuery(GET_STATS, {
    variables: { data: { agent_id: agentId } },
  });
  const [dailyStats, setDailyStats] = useState<any[]>([]);
  const [activeAreas, setActiveAreas] = useState<
    Record<'messages' | 'users' | 'conversations', boolean>
  >({
    messages: true,
    users: false,
    conversations: false,
  });

  const handleClickedButtonArea = (
    area: 'messages' | 'users' | 'conversations',
  ) => {
    setActiveAreas((prev) => {
      const newActiveAreas: any = {
        ...prev,
        [area]: !prev[area],
      };

      const isAtLeastOneAreaActive = Object.values(newActiveAreas).some(
        (isActive) => isActive,
      );

      if (!isAtLeastOneAreaActive) {
        return prev;
      }

      return newActiveAreas;
    });
  };

  useEffect(() => {
    if (stats) {
      const dailyStats = stats.get_agent_stats.data.days;
      setDailyStats(dailyStats);
    }
  }, [stats]);

  if (loading) {
    return null;
  }
  const totalMessages =
    stats.get_agent_stats.data.subscription.subscription_plan;
  const reaminingMessages =
    stats.get_agent_stats.data.subscription.subscription_plan -
    stats.get_agent_stats.data.subscription.consumed_messages;
  const currentMessages =
    stats.get_agent_stats.data.summary.weeklyPerformance.weeklyStats.messages
      .current;
  const currentConversations =
    stats.get_agent_stats.data.summary.weeklyPerformance.weeklyStats
      .conversations.current;
  const currentUsers =
    stats.get_agent_stats.data.summary.weeklyPerformance.weeklyStats.users
      .current;

  const reaminingMessagesPercentage = (reaminingMessages / totalMessages) * 100;
  return (
    <div className="m-auto h-full max-w-[1200px] overflow-y-auto px-6 pt-12">
      <Head title={t('page_title')} />
      <h1 className="pb-2 text-2xl font-bold">{t('page_title')}</h1>
      <p className=" text-sm">{t('description')}</p>

      <h2 className="mb-4 mt-8 text-xl font-medium">{t('weekly_summary')}</h2>
      <div className=" flex flex-row flex-wrap justify-center gap-4">
        <div className="bg-base-100 flex w-[270px]  flex-col justify-center rounded-lg py-4 text-center">
          <h6>{t('consumed_messages')}</h6>
          <p className="text-xs">{`(${t('cut_off_date')}: ${moment(
            stats.get_agent_stats.data.subscription.cutoff_date,
          ).format('DD/MM/YYYY')})`}</p>
          <div className="flex justify-center pt-4">
            <div className=" w-[162px] ">
              <CircularProgressbar
                value={reaminingMessagesPercentage}
                circleRatio={0.5}
                strokeWidth={16}
                styles={{
                  root: {
                    transform: 'rotate(0.75turn)',
                  },
                  path: { stroke: '#36D399', strokeLinecap: 'butt' },
                  trail: { stroke: '#C4C4C4', strokeLinecap: 'butt' },
                }}
              />
              <div className="mt-[-7rem] flex flex-col items-center gap-1 text-xs font-light">
                <p>{t('left')}</p>
                <NumberComponent
                  size="text-lg"
                  totalNumber={reaminingMessages}
                />

                <p className="flex justify-center gap-1">
                  {`${t('of')} ${formatter.format(
                    stats.get_agent_stats.data.subscription.subscription_plan,
                  )}`}
                </p>
              </div>
            </div>
          </div>
        </div>
        <StatsCard
          icon={TotalUsers}
          title={t('users')}
          previous={
            stats.get_agent_stats.data.summary.weeklyPerformance.weeklyStats
              .users.previous
          }
          totalNumber={
            stats.get_agent_stats.data.summary.weeklyPerformance.weeklyStats
              .users.current
          }
        />
        <StatsCard
          icon={IconMessage}
          title={t('conversations')}
          previous={
            stats.get_agent_stats.data.summary.weeklyPerformance.weeklyStats
              .conversations.previous
          }
          totalNumber={
            stats.get_agent_stats.data.summary.weeklyPerformance.weeklyStats
              .conversations.current
          }
        />
        <StatsCard
          icon={MessageYellow}
          title={t('messages')}
          previous={
            stats.get_agent_stats.data.summary.weeklyPerformance.weeklyStats
              .messages.previous
          }
          totalNumber={
            stats.get_agent_stats.data.summary.weeklyPerformance.weeklyStats
              .messages.current
          }
        />
      </div>
      {/* <div className="mt-12 flex flex-row justify-end gap-8 px-6">
        <button className="btn h-[40px] w-[370px] rounded-full border-black bg-[#FFFFFF] text-[12px] text-black hover:border-[#A10048] hover:bg-[#fdf5fd] hover:text-[#A10048]">
          <IconCalendar className=" fill-black hover:fill-[#A10048]" />
          Periodo desde 1 Ene 2024 - hasta 1 Jul 2024
          <img src={arrowButton} className="h-[20px] w-[20px]" alt="Arrow" />
        </button>
        <button className="btn h-[40px] w-[185px] rounded-full bg-[#E44277] text-[12px] text-[#FFFFFF] hover:bg-[#d8396e] ">
          <img src={IconDonwload} className="" alt="Donwload" />
          Descarga reporte
        </button>
      </div> */}
      <div className="mt-4 flex flex-row flex-wrap justify-center gap-4">
        <div className="bg-base-100 flex h-[108px] w-[28rem] flex-row items-center justify-between rounded-lg px-4 py-2">
          <div className="flex flex-col">
            <p className="text-sm">{t('avg_messages_per_conversation')}</p>
            <p className="pt-2 font-bold">
              {!currentConversations
                ? 0
                : formatter.format(currentMessages / currentConversations)}
            </p>
          </div>
          <IconMessageDos
            className="h-[40px] w-[40px] text-current"
            aria-label="Conversation"
          />
        </div>
        <div className="bg-base-100 flex h-[108px] w-[28rem] flex-row items-center justify-between rounded-lg px-4 py-2">
          <div className="flex flex-col">
            <p className="text-sm">{t('avg_conversations_per_user')}</p>
            <p className="pt-2 font-bold">
              {!currentConversations
                ? 0
                : formatter.format(currentConversations / currentUsers)}
            </p>
          </div>
          <IconConversation
            className="h-[40px] w-[40px] text-current"
            aria-label="Message"
          />
        </div>
      </div>
      <h2 className="mb-4 mt-8 text-xl font-medium">{t('last_30_days')}</h2>
      <div className="bg-base-100 my-8 flex w-full flex-col items-center gap-6 rounded-lg p-8">
        <div className="my-4 flex flex-row gap-2">
          <button
            className={`${
              activeAreas.messages ? 'bg-custom-surface-300' : ''
            } btn btn-primary flex w-[180px] shrink-0 items-center justify-between gap-1 rounded-md`}
            onClick={() => handleClickedButtonArea('messages')}
          >
            {t('messages')}
            <span className="w-4 border border-[#C9A4A8]" />
          </button>
          <button
            className={`${
              activeAreas.users ? 'bg-custom-surface-300' : ''
            } btn btn-primary flex w-[180px] shrink-0 items-center justify-between gap-1 rounded-md`}
            onClick={() => handleClickedButtonArea('users')}
          >
            {t('users')}
            <span className="w-4 border border-[#d19865]" />
          </button>
          <button
            className={`${
              activeAreas.conversations ? 'bg-custom-surface-300' : ''
            } btn btn-primary flex w-[180px] shrink-0 items-center justify-between gap-1 rounded-md`}
            onClick={() => handleClickedButtonArea('conversations')}
          >
            {t('conversations')}
            <span className="w-4 border border-[#a23056]" />
          </button>
        </div>
        <AreaChart
          width={730}
          height={250}
          data={dailyStats}
          margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
        >
          <defs>
            <linearGradient id="messages" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#C9A4A8" stopOpacity={0.8} />
              <stop offset="95%" stopColor="#C9A4A8" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="users" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#d19865" stopOpacity={0.8} />
              <stop offset="95%" stopColor="#d19865" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="conversations" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#a23056" stopOpacity={0.8} />
              <stop offset="95%" stopColor="#a23056" stopOpacity={0} />
            </linearGradient>
          </defs>
          <XAxis dataKey="day" />
          <YAxis />
          <CartesianGrid strokeDasharray="3 3" />
          <Tooltip />
          {activeAreas.messages && (
            <Area
              type="monotone"
              dataKey="messages"
              stroke="#C9A4A8"
              fillOpacity={1}
              fill="url(#messages)"
            />
          )}
          {activeAreas.users && (
            <Area
              type="monotone"
              dataKey="users"
              stroke="#d19865"
              fillOpacity={1}
              fill="url(#users)"
            />
          )}
          {activeAreas.conversations && (
            <Area
              type="monotone"
              dataKey="conversations"
              stroke="#a23056"
              fillOpacity={1}
              fill="url(#conversations)"
            />
          )}
        </AreaChart>
      </div>
    </div>
  );
};

export default ConsumerStats;
